
export default function Pricing() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Simple, Performance-Based Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Pay only for results. No upfront costs, no monthly fees. You only pay when we successfully connect you with new patients.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-gray-200 hover:border-blue-300 transition-colors">
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Individual Patient</h3>
              <div className="text-5xl font-bold text-blue-600 mb-2">$200</div>
              <p className="text-gray-600">per successful acquisition</p>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Pre-qualified patient leads</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Location-based matching</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Income verification</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Specialty alignment</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">No upfront costs</span>
              </li>
            </ul>
            <button 
              onClick={scrollToContact}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border-2 border-blue-500 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold">Most Popular</span>
            </div>
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Couple Package</h3>
              <div className="text-5xl font-bold text-blue-600 mb-2">$350</div>
              <p className="text-gray-600">per successful couple acquisition</p>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Two patients for one fee</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Family-focused matching</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Higher lifetime value</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">All individual benefits</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Better ROI potential</span>
              </li>
            </ul>
            <button 
              onClick={scrollToContact}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-2xl shadow-sm border-2 border-orange-300 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold">Premium Service</span>
            </div>
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Priority Membership</h3>
              <div className="text-5xl font-bold text-orange-600 mb-2">$97</div>
              <p className="text-gray-600">per month + success fees</p>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Immediate lead notifications</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Direct phone calls for your area</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Appointment setup assistance</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">Priority over non-members</span>
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                <span className="text-gray-700">All standard benefits</span>
              </li>
            </ul>
            <button 
              onClick={scrollToContact}
              className="w-full bg-orange-600 text-white py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join Priority
            </button>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white p-8 rounded-2xl shadow-sm max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Why Our Pricing Works</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-xl text-green-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">No Risk</h4>
                <p className="text-gray-600 text-sm">Pay only when you sign up a new patient</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-line-chart-line text-xl text-blue-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Scalable</h4>
                <p className="text-gray-600 text-sm">Grow at your own pace</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-money-dollar-circle-line text-xl text-purple-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Transparent</h4>
                <p className="text-gray-600 text-sm">Clear, upfront pricing</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
